export const SITE_NAME = "Boardblend";
export const SITE_ORIGIN = "https://boardblend.com";
export const SITE_ORGANIZATION_ID = `${SITE_ORIGIN}/#organization`;
export const SITE_WEBSITE_ID = `${SITE_ORIGIN}/#website`;

export type StaticPublicPage = {
  description: string;
  lastModified: string;
  path: string;
  title: string;
};

export const staticPublicPages = {
  home: {
    description:
      "Boardblend brings every teammate and their AI agent into one shared visual canvas for parallel brainstorming, clearer decisions, and an actionable plan.",
    lastModified: "2026-07-30",
    path: "/",
    title: "Collaborative AI Brainstorming for Teams · Boardblend",
  },
  workshops: {
    description:
      "Live workshops for teams deciding what to build. Think independently, investigate with your AI, and decide together.",
    lastModified: "2026-10-15",
    path: "/workshops",
    title: "Workshops by Boardblend",
  },
  privacy: {
    description:
      "Learn how Boardblend collects, uses, shares, stores, and protects account, billing, workspace, transcript, upload, and AI-connection data.",
    lastModified: "2026-07-30",
    path: "/privacy",
    title: "Privacy Policy · Boardblend",
  },
  resources: {
    description:
      "Practical guides and honest product comparisons for AI-assisted team brainstorming, feature prioritization, and clearer shared decisions.",
    lastModified: "2026-07-30",
    path: "/resources",
    title: "Team Brainstorming and Decision Resources · Boardblend",
  },
  terms: {
    description:
      "Read the terms that govern Boardblend accounts, collaborative sessions, subscriptions, user content, connected AI services, and acceptable use.",
    lastModified: "2026-07-30",
    path: "/terms",
    title: "Terms of Use · Boardblend",
  },
} satisfies Record<string, StaticPublicPage>;

export const defaultSocialImage = {
  alt: "Boardblend — Stronger team decisions, powered by everyone’s own AI.",
  height: 630,
  path: "/og-boardblend.png",
  width: 1200,
};

export function getCanonicalUrl(path: string) {
  return `${SITE_ORIGIN}${path}`;
}
